import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { Row, Col } from "react-bootstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import { CSVLink } from "react-csv";
import moment from "moment";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import {
  GetQuestionParentList,
  DeleteQuestionParentRecords,
} from "../../services/QuestionsService";
import { toast } from "react-toastify";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
} from "helpers/utils";

import delete_icon from "../../assets/images/icon/delete.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { useTranslation } from "react-i18next";

const QuestionParentList = () => {
  const { t } = useTranslation();
  const [questionParentList, setQuestionParentList] = useState([]);
  const [query, setQuery] = useState("");
  const [csvData, setCSVData] = useState([]);
  const companyId = localStorage.getItem("subdomainId");

  useEffect(() => {
    GetQuestionParentList()
      .then(res => {
        if (res?.data?.status) {
          setQuestionParentList(res?.data?.data);
        }
      })
      .catch(err => {
        toast.error("No data Available");
      });
    document.title = "NeuroTal - Question Parent List";
  }, []);

  const handleDeleteRecords = id => {
    DeleteQuestionParentRecords(id)
      .then(res => {
        if (res?.status === 200) {
          console.log(res);
          let messages = toast.success(res?.data?.message);
          window.location.href = "/question-parent-list";
        } else {
          let messages = toast.success(res?.data?.message);
          console.error("Delete record failed:", res?.data?.message);
        }
      })
      .catch(error => {
        console.error("Error deleting record:", error);
      });
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`mcq_manager.Showing rows`)} {from} {t(`mcq_manager.to`)} {to}{" "}
      {t(`mcq_manager.of`)} {size}
    </span>
  );

  //Handle CSV

  const handleCSVDownload = async e => {
    e.preventDefault();
    let data = questionParentList?.filter(renderCheck);
    setCSVData(data);
    setTimeout(() => {
      let element = document.getElementById("downloadCSV");
      element.click();
    }, 1000);
  };

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle: "First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  let columns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
    },
    {
      dataField: "ques_parent",
      text: t(`mcq_manager.Question Parent`),
      classes: "ques_parent", // Custom class for table cells
      headerClasses: "ques_parent", // Custom class for the header
    },
    {
      dataField: "ques_parent_desc",
      text: t(`mcq_manager.Question Parent Description`),
      classes: "ques_parent_desc", // Custom class for table cells
      headerClasses: "ques_parent_desc", // Custom class for the header
      formatter: cellContent => <ReadMore content={cellContent} />,
    },
    {
      dataField: "Company.company_name",
      text: "Company Name",
      hidden: companyId, // Hide the column if companyId exist
    },

    {
      dataField: "question_type.ques_type",
      text: t(`mcq_manager.Question Type`),
    },

    {
      dataField: "createdAt",
      text: t(`mcq_manager.Created At`),
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },
    {
      dataField: "status",
      text: t(`mcq_manager.Status`),
      formatter: (cellContent, row) => (
        <>
          {row?.status == "1"
            ? t(`mcq_manager.Active`)
            : t(`mcq_manager.Inactive`)}
        </>
      ),
    },
  ];

  if (checkPermissionStatus("question-parent-list", "edit")) {
    columns.push({
      dataField: "",
      text: t(`mcq_manager.Actions`),
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/edit-question-parent/${row.id}`}
                title="Edit Competency Category"
              >
                <img src={edit_icon} alt="edit_icon" />
                <span>Edit</span>
              </Link>
            </div>

            <div className="action-one small-img">
              <div
                onClick={() => handleDeleteRecords(row.id)}
                className="text-success blue-icon blue-color3"
                style={{ cursor: "pointer" }}
                to="#"
                title="Delete Record"
              >
                <img src={delete_icon} alt="delete_icon" />
                <span>Delete</span>
              </div>
            </div>
          </div>
        );
      },
    });
  }

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const renderCheck = item => {
    const searchableText = (
      item?.ques_parent +
      moment(getCompanyTimezoneDateTime(item?.createdAt)).format(
        "DD MMM YYYY"
      ) +
      (item?.status === "1" ? "Active" : "In Active")
    ).toLowerCase();
    return searchableText.includes(query.toLowerCase());
  };

  
  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const ReadMore = ({ content }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleReadMore = () => setIsExpanded(!isExpanded);

    const maxLength = 100; // Adjust to your preferred character limit

    // If content is short, show it fully without any button
    if (content.length <= maxLength) {
      return <>{content}</>;
    }
    if (!checkPermissionStatus("question-parent-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

    return (
      <div>
        {isExpanded ? content : `${content.substring(0, maxLength)}...`}
        <button onClick={toggleReadMore} className="readmoreless">
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      </div>
    );
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  return (
    <>
      <div className="pending-list-page feedbacks">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            // aria-labelledby="pills-home-tab"
          >
            {/* <div className="joblist-container mt-2">
            <Row className="mb-3 align-items-center">
              <Col sm="8">
                <h5 className="text-uppercase heading-one">
                  {" "}
                  Question Parent List
                </h5>
              </Col>
            </Row>
          </div> */}

            <div className="joblist-container create-vacancy main-pages-s">
              <Row className="mb-2 align-items-center">
                <Col lg="6" md="6">
                  <Link to="/dashboard">
                    <h5 className="text-uppercase heading-one">
                      <img src={arrow_btn} alt="arrow_btn" />
                      {t(`mcq_manager.Question Parent List`)}
                    </h5>
                  </Link>
                </Col>
              </Row>
            </div>

            <div className="outerTab-box-wrapper below-vacancy  amsterresign  applicationcard-table">
              <div className="tabel-application table-responsive pb-3">
                <div className="table-data-search moile-ar">
                  <div className="total-record">
                    <h5>
                      {t(`mcq_manager.Total Records`)}:{" "}
                      <span>{questionParentList?.length || 0}</span>
                    </h5>
                  </div>
                  <div className="total-serachbar">
                    <div className="serach-bar-top">
                      <form class="form-inline">
                        <input
                          class="form-control mr-sm-2"
                          type="search"
                          placeholder={t(
                            `mcq_manager.Search by question parent`
                          )}
                          aria-label="Search"
                          onChange={e => setQuery(e.target.value)}
                          title={t(`mcq_manager.Search by question parent`)}
                        />
                        <span>
                          <img src={serach_icon} alt="search" />
                        </span>
                      </form>
                    </div>

                    {checkPermissionStatus(
                      "question-parent-list",
                      "downloadcsv"
                    ) && (
                      <div className="take-text">
                        <CSVLink
                          data={csvData}
                          headers={[
                            {
                              key: "id",
                              label: "S No.",
                            },
                            {
                              key: "ques_parent",
                              label: t(`mcq_manager.Question Parent`),
                            },
                            {
                              key: "ques_parent_desc",
                              label: t(
                                `mcq_manager.Question Parent Description`
                              ),
                            },

                            {
                              key: "question_type.ques_type",
                              label: t(`mcq_manager.Question Type`),
                            },
                            {
                              key: "status",
                              label: t(`mcq_manager.Status`),
                            },
                            {
                              key: "createdAt",
                              label: t(`mcq_manager.Created At`),
                            },
                            {
                              key: !companyId ? "Company.company_name" : "", // Conditionally include "Company Name" if companyId does't exists
                              label: !companyId ? "Company Name" : "",
                            },
                          ]}
                          filename={`QuestionParentList.csv`}
                          id="downloadCSV"
                        >
                          <Button
                            color="info"
                            onClick={e => handleCSVDownload(e)}
                            outline
                          >
                            <img src={dowanload_csv} alt="Download" />{" "}
                            {t(`mcq_manager.Download CSV`)}
                          </Button>
                        </CSVLink>
                      </div>
                    )}

                    {checkPermissionStatus(
                      "question-parent-list",
                      "create"
                    ) && (
                      <div className="take-text filter">
                        <Link
                          to="/create-question-parent"
                          className="btn btn-primary"
                        >
                          + {t(`mcq_manager.Create`)}
                        </Link>
                      </div>
                    )}

                    <div className="tale-text right-panel">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip="Scroll Left"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip="Scroll Right"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                    </div>
                  </div>
                </div>

                {/* <div className="timeto-hire-card userlist questionparent"> */}
                <div className="timeto-hire-card userlist pendiglist-cardss">
                  <div className="table-custome-class range-custome">
                    <div className="scroll-container">
                      <div className="table-pending-list">
                        {questionParentList?.length > 0 && (
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <BootstrapTable
                              keyField="id"
                              data={questionParentList?.filter(renderCheck)}
                              columns={columns}
                              pagination={paginationFactory(options)}
                              rowClasses={rowClasses}
                              hover
                              responsive
                            />
                          </div>
                        )}

                        {questionParentList?.length === 0 && (
                          <>
                            <div className="no-data data-available">
                              <img
                                src="../../img/data-not-available.png"
                                alt="data not availble"
                              />
                              <h3> {t(`mcq_manager.No Item Found`)}</h3>
                              <p>
                                {t(`mcq_manager.Sorry, we could not find any`)}
                                <br /> {t(`mcq_manager.Item to show here`)}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionParentList;
